import {
  ProductStaBonusCreateBody,
  ProductStaBonusDetailResponse,
  ProductStaBonusItem,
  ProductStaBonusListResponse,
} from "../types"

export class ProductStaBonus {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }

  create(
    vendorId: string,
    productId: string,
    body: ProductStaBonusCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ProductStaBonusItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/products/${productId}/sta-bonus`,
        {
          method: "POST",
          headers,
          body,
          query,
        }
      )
    })()
  }

  update(
    id: string,
    vendorId: string,
    productId: string,
    body: ProductStaBonusCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ProductStaBonusItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/products/${productId}/sta-bonus/${id}`,
        {
          method: "PUT",
          headers,
          body,
          query,
        }
      )
    })()
  }

  list(
    vendorId: string,
    productId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ProductStaBonusListResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/products/${productId}/sta-bonus`,
        {
          headers,
          query: queryParams,
        }
      )
    })()
  }

  retrieve(
    id: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ProductStaBonusDetailResponse> {
    return (async () => {
      const { vendorId, productId, ...reset } = queryParams as any
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/products/${productId}/sta-bonus/${id}`,
        {
          query: reset,
          headers,
        }
      )
    })()
  }

  delete(
    id: string,
    vendorId: string,
    productId: string,
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/products/${productId}/sta-bonus/${id}`,
        {
          method: "DELETE",
          headers,
        }
      )
    })()
  }
}
